<template>
    <div class="hts-workflow-position">
        <div class="max-w-full overflow-x-auto mb-5">
            <ul class="steps mb-5">
                <li
                    v-for="(item, index) in positions"
                    :key="index"
                    class="flex items-center flex-col w-72 justify-start step"
                    :class="{ 'step-primary': checkActive(item, index) }">
                    <div class="w-72 mr-2">
                        <slot
                            :item="item"
                            :index="index" />
                    </div>
                    <span
                        class="hts-workflow-position-step-color"
                        :style="getStyle(item, index)">
                        {{ index + 1 }}
                    </span>
                    <div class="space-y-2">
                        <hts-form-button
                            v-if="!item.startPosition && !item.endPosition"
                            size="small"
                            class="!block"
                            color="success"
                            @click="setStartPosition(item, index)">
                            Set start position
                        </hts-form-button>
                        <template v-else-if="item.startPosition">
                            <div class="border rounded-md borer-green-500 bg-green-500 text-white text-center py-1 px-2">
                                Start
                            </div>
                            <div class="h-[28px]" />
                        </template>
                        <hts-form-button
                            v-if="!item.endPosition && !item.startPosition"
                            size="small"
                            class="!block"
                            color="error"
                            @click="setEndPosition(item, index)">
                            Set end position
                        </hts-form-button>
                        <template v-else-if="item.endPosition">
                            <div class="border rounded-md borer-red-500 bg-red-500 text-white text-center py-1 px-2">
                                End
                            </div>
                            <div class="h-[28px]" />
                        </template>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  positions: {
    type: Array as PropType<any[]>,
    required: true
  },
  samePositions: Array,
  isActive: [Boolean, Function]
})
const { positions, samePositions, isActive } = toRefs(props)
const { $colors } = useNuxtApp()

watch(
  () => positions.value,
  () => {
    colorList.value = {}
  }
)

const checkActive = (item: any, index: number) => {
  if (!isActive) {
    return false
  }
  if (typeof isActive.value === 'function') {
    return isActive.value(item, index)
  }
  return isActive.value
}

const colorList = ref<{ [key: string]: string }>({})
const samePositionFormatted = computed(() => {
  if (samePositions && Array.isArray(samePositions.value) && samePositions.value.length) {
    const temp: number[][] = []
    samePositions.value.forEach(([p1, p2]: any) => {
      const exists1: number[][] = temp.filter((i) => i.includes(p1))
      const exists2: number[][] = temp.filter((i) => i.includes(p2))
      if (exists1.length && exists2.length) {
        return
      }
      if (exists1.length && !exists2.length) {
        return exists1[0].push(p2)
      }
      if (exists2.length && !exists1.length) {
        return exists2[0].push(p1)
      }
      temp.push([p1, p2])
    })
    return temp
  } else {
    return []
  }
})
const getStyle = (item: any, index: number): any => {
  if (samePositionFormatted.value.length) {
    const exists: number[][] = samePositionFormatted.value.filter((i) => i.includes(index))
    if (exists.length) {
      let color: null | string = null
      exists[0].forEach((i) => {
        if (colorList.value[i.toString()]) {
          color = colorList.value[i.toString()]
        }
      })
      if (!color) {
        colorList.value[index.toString()] = $colors.random()
      }
      return {
        backgroundColor: color
      }
    }
    return {
      backgroundColor: '#03b4f2'
    }
  }
  if (checkActive(item, index)) {
    return {
      backgroundColor: '#03b4f2'
    }
  }
}

const setStartPosition = (item: any, index: number) => {
  positions.value.forEach((item) => {
    item.startPosition = false
  })
  positions.value[index].startPosition = true
}

const setEndPosition = (item: any, index: number) => {
  positions.value.forEach((item) => {
    item.endPosition = false
  })
  positions.value[index].endPosition = true
}
</script>
